// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-header-right[data-v-6925b810] {\n  position: absolute;\n  top: 40px;\n  bottom: 0;\n  right: 30px;\n}\n.page-header-actions[data-v-6925b810] {\n  margin-top: 40px;\n  position: absolute;\n  bottom: 20px;\n}\n.panel[data-v-6925b810] {\n  margin-top: 3px;\n}\n.show_entries[data-v-6925b810] {\n  margin-top: 20px;\n}\n.Excel[data-v-6925b810] {\n  margin: auto 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
